export default {
      id: "ic_telegram-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ic_telegram",
      toString: function () {
        return this.url;
      }
    }